import { Navigate, Outlet } from 'react-router-dom'

import { useAuthStore } from '@/stores/auth'

import { paths } from '@/config/paths'

import { useHasViewableMembership, useIsMember } from '@/hooks/useMembership'

/**
 * Route guard that checks if a member has viewable membership (active or paused).
 * Members without active or paused membership are redirected to select-plan page.
 * This guard only applies to members - other roles pass through normally.
 *
 * Use this for routes where members should be able to view their historical data
 * (payments, notes, health tracking) even if their membership is paused.
 */
export default function ViewOnlyMembershipRoute() {
  const user = useAuthStore((state) => state.user)
  const isMember = useIsMember()
  const hasViewableMembership = useHasViewableMembership()

  if (!user) return <Navigate to={paths.public.auth.login.path} replace />

  // Only apply membership check to members
  if (isMember && !hasViewableMembership) {
    // Redirect to plan selection if member doesn't have active or paused membership
    return <Navigate to={paths.dashboard.member.selectPlan.path} replace />
  }

  return <Outlet />
}
